import LineArea from './LineArea';
export default  LineArea;